import React, {useEffect, useState} from 'react';
import styles from './security-details-modal-content.module.scss';
import {Row, Col, Table, Spinner, ProgressBar} from 'react-bootstrap';
import {
  COUPON_FREQUENCY_OTHERS,
  COUPON_FREQUENCY_ZERO,
  COUPON_TYPE_DISCOUNT,
  COUPON_TYPE_FIXED,
  COUPON_TYPE_FLOATING,
  COUPON_TYPE_STEPPED,
  LISTING_REVISE_AO_ERROR,
  LISTING_REVISE_AO_SUCCESS,
  LISTING_REVISE_OFFER_SIZE_ERROR,
  LISTING_REVISE_OFFER_SIZE_SUCCESS
} from "../../../../../../helpr/constants";
import {dateBetween, formatDate, strToDate, toCurrency, toPercentage} from "../../../../../../helpr/helper";
import { getCouponTypes, getCouponFrequencies } from "../../../../../../helpr/listingFormData";
import checkIcon from "../../../../../../assets/orders-table-accept.svg";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import editIcon from "../../../../../../assets/edit.svg";
import {useValidation} from "../../../../../../hooks/use-validation";
import {numeric, required} from "../../../../../../helpr/generic-validation-rules";
import {CurrencyInput, TextInput} from "../../../../../../components/form/form";
import ListingService from "../../../../../../services/listing-service";
import Transfer from "../../../../../../models/transfer";
import {Security} from "../../../../../../models/security";
import Order from "../../../../../../models/order";
import {REDUCER_ACTION_INITIALIZE} from "../../../../../../context/security-context";

const SecurityDetailsModalContent = ({termSheet, security, setSecurityList, onClose, admin, editAllowed, institutionCode}) => {

  const [revisionState, setRevisionState] = useState(security.current.amountHistory)
  const [reservations, setReservations] = useState(0);
  const [reservationList, setReservationList] = useState([]);
  const [ toggleEditFields, setToggleEditFields ] = useState(false);
  const [ toggleEditFieldsAO, setToggleEditFieldsAO ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ loadingAO, setLoadingAO ] = useState(false);
  const [ loadingR, setLoadingR ] = useState(false);
  const [ txMessage, setTxMessage ] = useState({
    style: '',
    msg:''
  });
  const [ txMessageAO, setTxMessageAO ] = useState({
    style: '',
    msg:''
  });
  const listingService = new ListingService();

  const reviseIssueAmountState = useValidation(
    reviseIssueAmountValidator,
    reviseIssueAmountObj(security.current.amount.toString(), security.current.amountOutstanding.toString()),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getField } = reviseIssueAmountState;

  useEffect(() => {
    const retrieveReservations = async () => {
      try {
        setLoadingR(true)
        let reservations = await listingService.retrieveReservations(institutionCode, termSheet.applicationId, security.current.securityId);
        setReservations(reservations.reservations);
        setReservationList(reservations.sa_list);
      }catch(error) {

      }finally {
        setLoadingR(false);
      }
    }
    if (security.current.securityId){
      retrieveReservations()
    }
    // eslint-disable-next-line
  }, [])

  const renderCouponFreqValue = key => getCouponFrequencies().filter(t => t.value === key)[0].name;
  const renderCouponTypeValue = key => getCouponTypes().filter(t => t.value === key)[0].name;
  const renderCouponFrequency = () => {
    return security.current.couponFrequency !== COUPON_FREQUENCY_ZERO && security.current.couponFrequency !== COUPON_FREQUENCY_OTHERS  ?
      (
        <>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Payment Dates:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponPaymentDate}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>First Payment Date:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{formatDate(security.current.couponFirstPaymentDate)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Record Date:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponRecordDate}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Close Period:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponClosedPeriod}</Col>
          </Row>
        </>
      ): '';
  }

  const renderCouponType = () => {
    switch(security.current.couponType){
      case COUPON_TYPE_DISCOUNT:
        return <Row>
          <Col xs={6} lg={6} className={styles['label']}>Discount Rate:</Col>
          <Col xs={6} lg={6} className={styles['value']}>{toPercentage(security.current.couponDiscountRate)}</Col>
        </Row>
      case COUPON_TYPE_FIXED:
        return <>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Interest Rate:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toPercentage(security.current.couponFixedInterestRate)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Rate Setting Date:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{formatDate(security.current.couponFixedRateSettingDate)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Reference Rate:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponFixedRefRateUsed}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Spread Over Reference Rate:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponFixedSpreadOverRefRate}</Col>
          </Row>
        </>;
      case COUPON_TYPE_FLOATING:
        return <Row>
          <Col xs={6} lg={6} className={styles['label']}>Basis:</Col>
          <Col xs={6} lg={6} className={styles['value']}>{security.current.couponFloatingRateBasis}</Col>
        </Row>
      case COUPON_TYPE_STEPPED:
        return <Row>
          <Col xs={6} lg={6} className={styles['label']}>Description:</Col>
          <Col xs={6} lg={6} className={styles['value']}>{security.current.couponSteppedProvisionDesc}</Col>
        </Row>
      default:
    }
  }

  const reviseIssueAmount = async () => {
    const { formState, isFormValid} = validate();
    console.log(isFormValid);
    if (!isFormValid){
      return
    }
    try{
      setLoading(true);
      const result = await listingService.reviseSecurityOfferSize(termSheet.applicationId, security.current.id, formState.amount)
      console.log(result);
      setRevisionState(prev => {
        const newList = prev.concat(result);
        return newList;
      });
      setSecurityList(prev => {
        const newList = prev.map(s => {
          if(s.id === security.current.id){
            return {
              ...s,
              amount: formState.amount,
              amountHistory: s.amountHistory.concat(result)
            }
          }
          return s
        })
        return newList;
      })
      setTxMessage({
        ...txMessage,
        msg: LISTING_REVISE_OFFER_SIZE_SUCCESS,
        style: 'success'
      });
      setToggleEditFields(!toggleEditFields);
    }catch(error){
      setTxMessage({
        ...txMessage,
        msg: LISTING_REVISE_OFFER_SIZE_ERROR,
        style: 'danger'
      })
    }finally {
      setLoading(false);
    }
  }

  const reviseAmountOutstanding = async () => {
    const { formState, isFormValid} = validate();
    console.log(isFormValid);
    if (!isFormValid){
      return
    }
    try{
      setLoadingAO(true);
      const result = await listingService.reviseSecurityAmountOutstanding(termSheet.applicationId, security.current.id, formState.amountOutstanding)
      console.log(result);
      setSecurityList(prev => {
        const newList = prev.map(s => {
          if(s.id === security.current.id){
            return {
              ...s,
              amountOutstanding: formState.amountOutstanding,
            }
          }
          return s
        })
        return newList;
      })
      setTxMessageAO({
        ...txMessageAO,
        msg: LISTING_REVISE_AO_SUCCESS,
        style: 'success'
      });
      setToggleEditFieldsAO(!toggleEditFieldsAO);
    }catch(error){
      setTxMessageAO({
        ...txMessageAO,
        msg: LISTING_REVISE_AO_ERROR,
        style: 'danger'
      })
    }finally {
      setLoadingAO(false);
    }
  }

  const toggleEditableFields = () => {
    setTxMessage({
      ...txMessage,
      msg: ''
    });
    setToggleEditFields(!toggleEditFields);
  }

  const toggleEditableFieldsAO = () => {
    setTxMessageAO({
      ...txMessageAO,
      msg: ''
    });
    setToggleEditFieldsAO(!toggleEditFieldsAO);
  }

  const renderEditableFields = (value, input) => {
    return toggleEditFields ? (
      <div className={styles['edit-field']}>
        {input}
        {!loading ?
          <>
            <div onClick={() => reviseIssueAmount()} className={styles['confirm-scale-down']}>
              <img alt="Confirm" src={checkIcon} />
            </div>
            <div onClick={() => toggleEditableFields()} className={styles['cancel-scale-down']}>
              <img alt="Cancel" src={rejectIcon}/>
            </div>
          </> : <div className={styles['loading-scale-down']}>
            <Spinner size="sm" animation="border" />
          </div>
        }
      </div>
    ) : (
      <div>
        {value}
        { termSheet.applicationStatus === '2' && !admin && beforeOfferCloses() && editAllowed() ?
        <img className={styles['edit']} onClick={()=>toggleEditableFields()} alt="Edit" src={editIcon} /> : ''}
      </div>
    )
  }

  const renderEditableFieldsAO = (value, input) => {
    return toggleEditFieldsAO ? (
      <div className={styles['edit-field']}>
        {input}
        {!loadingAO ?
          <>
            <div onClick={() => reviseAmountOutstanding()} className={styles['confirm-scale-down']}>
              <img alt="Confirm" src={checkIcon} />
            </div>
            <div onClick={() => toggleEditableFieldsAO()} className={styles['cancel-scale-down']}>
              <img alt="Cancel" src={rejectIcon}/>
            </div>
          </> : <div className={styles['loading-scale-down']}>
            <Spinner size="sm" animation="border" />
          </div>
        }
      </div>
    ) : (
      <div>
        {value}
        { termSheet.applicationStatus === '2' && !admin && beforeOfferCloses() && editAllowed() ?
          <img className={styles['edit']} onClick={()=>toggleEditableFieldsAO()} alt="Edit" src={editIcon} /> : ''}
      </div>
    )
  }

  const beforeOfferCloses = () => {
    const end = strToDate(formatDate(termSheet.offerPeriodTo));
    const now = new Date()
    now.setHours(0,0,0,0);
    return now <= end
  }

  return (
    <div className={styles['security-details-modal-content']}>
      <Row>
        <Col lg={12}>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Security ID/ISIN No.</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.securityId ? security.current.securityId : '-'}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Security Code</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.securityCode ? security.current.securityCode : '-'}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Long Name</Col>
            <Col xs={6} lg={6} className={`${styles['value']} ${styles['wrap']}`}>{security.current.longName}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Preferred Name</Col>
            <Col xs={6} lg={6} className={`${styles['value']} ${styles['wrap']}`}>{security.current.prefShortName}</Col>
          </Row>
          {security.current.securityId ?
            <>
              <Row>
                <Col xs={6} lg={6} className={styles['label']}>Reservations</Col>
                <Col xs={6} lg={6} className={styles['value']}>{loadingR ? <Spinner size="sm" animation="border" /> : toCurrency(reservations)}</Col>
              </Row>
              <Row>
                {/*<Col xs={6} lg={6} className={styles['label']}></Col>*/}
                <Col xs={12} lg={12} className={styles['value']}>
                  {loadingR ? <Spinner size="sm" animation="border" />
                  : <Table responsive>
                      <thead>
                      <tr>
                        <th>Selling Agent</th>
                        <th>Reservations</th>
                        <th>Status</th>
                      </tr>
                      </thead>
                      <tbody>
                      {
                        reservationList.map((r, index) => {
                          return (
                            <tr key={index}>
                              <td className={styles['selling-agent-column']}>
                                {r.sellingAgentName}
                              </td>
                              <td className={styles['reservations-column']} >
                                {toCurrency(r.total)}
                              </td>
                              <td>
                                <ProgressBar className={styles['progress']} now={r.percentageCompletion} label={`${r.percentageCompletion}%`} />
                              </td>
                            </tr>
                          )
                        })
                      }
                      </tbody>
                    </Table>
                  }
                </Col>
              </Row>
            </> : ''
          }
          <Row>
            <Col lg={12}><div className={styles['line']}></div></Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Country of Issue</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.countryOfIssue}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Issue Currency</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.currency}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Issue/Listing Date</Col>
            <Col xs={6} lg={6} className={styles['value']}>{formatDate(security.current.listingDate)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Maturity Date</Col>
            <Col xs={6} lg={6} className={styles['value']}>{formatDate(security.current.maturityDate)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Issue / Reopening Amount</Col>
            <Col xs={6} lg={6} className={styles['value']}>{renderEditableFields(toCurrency(getField('amount')),
              <CurrencyInput inputProps={getTextFieldProps('amount')} placeholder={""} />)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6}></Col>
            <Col xs={6} lg={6} className={styles[txMessage.style]}>{txMessage.msg}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Total Amount Outstanding (for Reopening)</Col>
            <Col xs={6} lg={6} className={styles['value']}>{renderEditableFieldsAO(toCurrency(getField('amountOutstanding')),
              <CurrencyInput inputProps={getTextFieldProps('amountOutstanding')} placeholder={""} />)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6}></Col>
            <Col xs={6} lg={6} className={styles[txMessageAO.style]}>{txMessageAO.msg}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Tenor</Col>
            <Col xs={6} lg={6} className={`${styles['value']} ${styles['wrap']}`}>{security.current.tenor}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Issue Price</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toPercentage(security.current.issuePrice)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Redemption Price</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toPercentage(security.current.redemptionPrice)}</Col>
          </Row>
          <Row>
            <Col lg={12}><div className={styles['line']}></div></Col>
          </Row>

          {security.current.redemptionDetail.length > 0 ?
            <>
              <Row>
                <Col>
                  <div className={styles['table-heading']}>
                    Optional Redemption Details
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table responsive>
                    <thead>
                    <tr>
                      <th>Optional Redemption Date</th>
                      <th>Optional Redemption Price</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      security.current.redemptionDetail.map((rd, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {rd.optional_redemption_date ? formatDate(rd.optional_redemption_date) : '-'}
                            </td>
                            <td >
                              {rd.optional_redemption_price ? toPercentage(rd.optional_redemption_price) : '-'}
                            </td>
                          </tr>
                        )
                      })
                    }
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </> : ''}
          <Row>
            <Col>
              <div className={styles['table-heading']}>
                Primary Market
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Minimum Denomination</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toCurrency(security.current.denomination.primary.minimum)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Minimum Increments</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toCurrency(security.current.denomination.primary.increments)}</Col>
          </Row>
          <Row>
            <Col>
              <div className={styles['table-heading']}>
                Secondary Market
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Minimum Denomination</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toCurrency(security.current.denomination.secondary.minimum)}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Minimum Increments</Col>
            <Col xs={6} lg={6} className={styles['value']}>{toCurrency(security.current.denomination.secondary.increments)}</Col>
          </Row>
          <Row>
            <Col lg={12}><div className={styles['line']}></div></Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Coupon Type:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponType ? renderCouponTypeValue(security.current.couponType) : ''}</Col>
          </Row>
          {renderCouponType()}
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Coupon Frequency:</Col>
            <Col xs={6} lg={6} className={styles['value']}>{security.current.couponFrequency ? renderCouponFreqValue(security.current.couponFrequency) : ''}</Col>
          </Row>
          {renderCouponFrequency()}
          <Row>
            <Col><div className={styles['spacing']}></div></Col>
          </Row>
          {revisionState.length > 0 ?
            <>
              <Row>
                <Col lg={12}><div className={styles['line']}></div></Col>
              </Row>
              <Row>
                <Col>
                  <div className={styles['table-heading']}>
                    Issue/Reopening Amount Revisions
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table responsive>
                    <thead>
                    <tr>
                      <th className={styles['align-right']}>Issue/Reopening Amount</th>
                      <th>Date of Revision</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      revisionState.map((ah, index) => {
                        return (
                          <tr key={index}>
                            <td className={styles['align-right']}>
                              {toCurrency(ah.amount)}
                            </td>
                            <td >
                              { index === 0 ? 'Initial' : ah.date}
                            </td>
                          </tr>
                        )
                      })
                    }
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </> : ''}
        </Col>
      </Row>
    </div>
  )
}

const reviseIssueAmountObj = (amount, amountOutstanding) => {
  return {
    fields: {
      amount: {
        value: amount,
        style: {}
      },
      amountOutstanding: {
        value: amountOutstanding,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const reviseIssueAmountValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    amount: [required],
    amountOutstanding: [required]
  },
  dynamicFields: {}
}

export default SecurityDetailsModalContent;
